import React from "react";
import { SectionUnlockingSwitch } from "features/AdminPanel/modules/SectionUnlockingSwitch/SectionUnlockingSwitch";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { useAccountSectionUnlocking } from "features/Account/utils/useAccountSectionChange";
import { FEATURE_KEYS } from "features/Account/modules/Features/constants/FeatureKeys.constants";
import { useRequestVerificationKRAModal } from "features/Account/modules/SubSectionWrapper/modules/RequestVerificationKRA/modules/utils/useRequestVerificationKRAModal";
import { FEATURE_STATUS } from "features/Account/Account.constants";
import { SectionLocked } from "features/AdminPanel/modules/SectionLocked/SectionLocked";
import ExlySwitch from "common/form/ExlySwitch";
import { UpgradePlanChip } from "features/AdminPanel/modules/UpgradePlanChip/UpgradePlanChip";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import { getSectionStates } from "features/AdminPanel/modules/utils/AdminPanel.utils";

export const KRAToggle = ({ subSectionKey }) => {
  const key = FEATURE_KEYS.KRA_FLOW;

  const isDesktop = useDesktopMediaQuery();
  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
  const subSectionConfig = sectionConfig[key] || {};
  const { value } = subSectionConfig;
  const { handleSectionChange } = useAccountSectionUnlocking();
  const { featureStatus } = useRequestVerificationKRAModal({
    key: subSectionKey,
  });
  const { isPlanLocked } = getSectionStates({
    status: subSectionConfig?.status,
  });

  const handleToggleChange = () => {
    const payload = {
      feature_key: key,
      feature_value: !value,
    };
    handleSectionChange({ payload, status: featureStatus });
  };

  if (isPlanLocked) {
    return (
      <div
        className={`tw-flex ${
          !isDesktop && "tw-flex-col"
        } tw-items-center tw-justify-between tw-w-full`}
      >
        <div className="tw-flex tw-items-center tw-gap-3">
          <ExlySwitch
            noIcon
            size="large"
            color="success"
            disabled
            input={{
              value: false,
              onChange: () => {},
            }}
          />
          <SectionLocked />
        </div>
        {isDesktop && <UpgradePlanChip />}
      </div>
    );
  } else {
    return (
      <div className="tw-flex tw-items-center">
        <SectionUnlockingSwitch
          disabled={featureStatus !== FEATURE_STATUS.ACCESS_GRANTED}
          value={value}
          onChange={handleToggleChange}
        />
      </div>
    );
  }
};
